import api from 'api'

export const updateMetric = async (id, payload) => {
  const { data } = await api.put(`/metric/${id}`, payload)

  return data
}
